import React, { useEffect } from 'react';
import { pluck, includes } from 'ramda';
import { isBlank } from 'utils/helperMethods';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@material-ui/core';
import MortgageSurveyQuestionPresenter from 'presenters/MortgageSurveyQuestionPresenter';
import MortgageSurveyPresenter, { PURPOSE_OPTIONS } from 'presenters/MortgageSurveyPresenter';

import useStyles from './useStyles';

const CashOutSelectQuestion = props => {
  const { question, onChange, onValidate, surveyValues } = props;
  const classes = useStyles();
  const [cashOutField, cashOutAmountField] = MortgageSurveyQuestionPresenter.surveyValueFields(question);
  const currentValue = MortgageSurveyPresenter[cashOutField](surveyValues);
  const currentCashOutAmountValue = MortgageSurveyPresenter[cashOutAmountField](surveyValues);

  useEffect(() => {
    const isValid = !isBlank(currentValue) && includes(currentValue, pluck('value', PURPOSE_OPTIONS));
    onValidate(isValid);
  }, [currentValue]);

  const options = MortgageSurveyQuestionPresenter.options(question);

  const handleSelectValue = value => () => {
    const defaultCashOutAmount = MortgageSurveyPresenter.isCashOut(value) ? currentCashOutAmountValue : null;
    onChange([{ field: cashOutField, value }, { field: cashOutAmountField, value: defaultCashOutAmount }]);
  };

  return (
    <Box>
      <Typography variant="h1">{MortgageSurveyQuestionPresenter.label(question)}</Typography>
      <Box mt={2} />
      <Typography variant="body1">{MortgageSurveyQuestionPresenter.description(question)}</Typography>
      <Box mt={4} />
      <Box display="flex" width="100%" my={3} flexWrap="wrap">
        {options.map(({ label, value }) => {
          const isSelected = currentValue === value;
          return (
            <Button
              key={value}
              onClick={handleSelectValue(value)}
              className={clsx(classes.button, { [classes.selected]: isSelected })}
            >
              {label}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
};

CashOutSelectQuestion.propTypes = {
  question: MortgageSurveyQuestionPresenter.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
  surveyValues: MortgageSurveyPresenter.shape().isRequired,
};

export default CashOutSelectQuestion;



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/CashOutSelectQuestion/CashOutSelectQuestion.js